(function(){
  const SELECTORS = [
    '.price',
    '.price-item',
    '.money',
    '.totals__total-value',
    '.cart-item__old-price',
    '.cart-item__final-price',
    '.cart-item__discounted-prices',
    '.product-option',
    '.price--end',
    '.mv-current-price',
    '.mv-old-price',
    '.mv-unit-price',
    '[data-mv-price]',
    '.mv-mobile-bar strong',
    '.gettmo-simple-card__price',
    '.gettmo-simple-card__compare',
    '.gm-order-card__total',
    '.discounts__discount',
    '.tax-note',
    '.totals',
    '.cart-drawer .totals__subtotal-value'
  ].join(',');

  function formatMoneyString(text) {
    if (!text || (!text.includes('Tk') && !text.includes('TK') && !text.includes('৳'))) return text;
    return text
      .replace(/(^|[^\d])(?:Tk|TK|৳)\s*([\d,]+)(?:\.\d+)?/g, function(match, prefix, number){
        return prefix + '৳' + number;
      })
      .replace(/(৳[\d,]+)\.\d+/g, '$1');
  }

  function processTextNodes(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        if (!node.nodeValue || !node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
        if (!/(Tk|TK|৳)/.test(node.nodeValue)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      node.nodeValue = formatMoneyString(node.nodeValue);
    });
  }

  function processScope(scope) {
    if (!scope) return;
    if (scope.matches && scope.matches(SELECTORS)) processTextNodes(scope);
    if (scope.querySelectorAll) scope.querySelectorAll(SELECTORS).forEach(processTextNodes);
  }

  let rafId = null;
  function scheduleProcess(scope) {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(() => {
      processScope(scope || document.body);
    });
  }

  document.addEventListener('DOMContentLoaded', function(){
    processScope(document.body);

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'characterData') {
          processTextNodes(mutation.target.parentElement || document.body);
          continue;
        }
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            scheduleProcess(node);
          } else if (node.nodeType === 3 && node.parentElement) {
            processTextNodes(node.parentElement);
          }
        });
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  });
})();
